export const TEXT_COMMON = {
  LOGO: 'Baby Track®',
  EDIT: '編集',
  VIEW: '閲覧',
  UPDATE: '編集する',
  DUPLICATE: '複製',
  RENEW: '更新',
  DELETE: '削除',
  EXECUTION: '実行',
  CANCEL_TEXT: 'キャンセル',
  CONFIRM_TEXT: 'ログアウト',
  LOGO_ATTACHED: '管理サイト',
  PASSWORD_REQUIRED_LENGTH: '8文字以上',
  PLACEHOLDER_EMAIL: 'example@gmail.com',
  PASSWORD_REQUIRED: '記号・英字の大小・数字の全てを含む',
  PASSWORD_REQUIRED_CHARACTER: '使用できる文字：半角の英字と数字',
  PASSWORD_REQUIRED_SYMBOL: '使用できる記号：! @ # $ % ^ & * ( ) _ + -',
  PUBLIC_TEXT: '公開中',
  UNPUBLIC_TEXT: '非公開する',
  DRAFT_TEXT: '下書き',
  PRIVATE_TEXT: '非公開',
  PLACEHOLDER_FROM_DATE: '開始日',
  PLACEHOLDER_TO_DATE: '終了日',
  PASSWORD_REVIEW: '・・・・・・・・・・・・・',
  CONFIRM_LEAVE_PAGE_EDIT: '編集中のデータが削除されます。よろしいでしょうか。?',
  DOWNLOAD_PDF_FILE: 'PDFファイルダウンロード',
  DOWNLOAD_CSV_FILE: 'CSVファイルダウンロード',
  REVERT_PUBLIC: '公開に戻す',
  YES: 'はい',
  QUESTION_NUMBER: '【質問${question_number}】',
  QUESTION_NUMBER_VIETNAM: 'Câu hỏi ${question_number}: ',
  FV_TEMPLATE: 'FV定型',
};

export const TEXT_HEADER = {
  SURVEY_LIST: '問診票一覧',
  ANSWER_LIST: '回答結果一覧',
  ACCOUNT_SETTING: 'アカウント情報設定',
  LOG_OUT: 'ログアウト',
  MODAL_CONFIRM_LOGOUT: 'ログアウトしますか？',
  USER_LIST: '子供一覧',
  EVALUATION_ANALYSIS_LIST: '評価分析一覧',
  SAMPLE_VIDEO_LIST: '運動動画一覧',
  EXERCISE_VIDEO_LIST: '運動動画一覧',
  CHAT_LIST: 'チャット一覧',
  CHANGE_LANGUAGE: '表示言語の変更',
  JAPANESE: '日本語',
  VIETNAMESE: 'ベトナム語',
  FACILITY_LIST: '施設一覧',
};

export const TEXT_LOGIN = {
  EMAIL_ADDRESS: 'メールアドレス',
  PASSWORD: 'パスワード',
  FORGET_PASSWORD_LINK_TEXT: 'パスワードをお忘れの方はこちら',
  LOGIN: 'ログイン',
  REGISTER_LINK_TEXT: '新規アカウント作成',
};

export const TEXT_REGISTER = {
  TITLE: TEXT_LOGIN.REGISTER_LINK_TEXT,
  EMAIL_ADDRESS: TEXT_LOGIN.EMAIL_ADDRESS,
  PASSWORD: TEXT_LOGIN.PASSWORD,
  STEP_TEXT_ENTER_ACCOUNT_INFO: 'アカウント情報入力',
  STEP_TEXT_CONFIRM_ACCOUNT_INFO: 'アカウント情報確認',
  REQUIRED_EMAIL_TEXT: '半角英数字で入力してください',
  PASSWORD_REQUIRED_TEXT: 'パスワードは、以下の条件を満たす必要があります：',
  CONFIRM_PASSWORD: 'パスワード再入力',
  MUNICIPALITY: '所属自治体',
  MUNICIPALITY_REQUIRED: '所属する自治体（例：東京都渋谷区）を入力してください',
  DEPARTMENT: '所属部署',
  DEPARTMENT_REQUIRED: '所属する部署（例：障がい福祉課）を入力してください',
  GO_TO_CONFIRM: '入力内容確認',
  CREATE_ACCOUNT: 'アカウントを作成',
  BACK_TO_ENTER: '修正する',
};

export const TEXT_FORGOT_PASSWORD = {
  BACK_TO_LOGIN: TEXT_LOGIN.LOGIN,
  EMAIL_ADDRESS: TEXT_LOGIN.EMAIL_ADDRESS,
  REQUIRED_EMAIL_TEXT: TEXT_REGISTER.REQUIRED_EMAIL_TEXT,
  PASSWORD_REQUIRED_TEXT: TEXT_REGISTER.PASSWORD_REQUIRED_TEXT,
  CONFIRM_NEW_PASSWORD: 'パスワードをリセット',
  SEND_PASSWORD_TO_MAIL: 'パスワードリセットURLを送信',
  SEND_EMAIL: 'リセットURLを送信',
  RESEND_LATER: '秒後再送信できます',
  SEND_TO_EMAIL_ABOVE: '上記のメールアドレスにリセットのURLを送信します。',
  NEW_PASSWORD: '新しいパスワード',
  SUBMIT_NEW_PASSWORD: '新しいパスワードに更新',
  NEW_PASSWORD_CONFIRM: '新しいパスワード再入力',
};

export const TEXT_SURVEY_LIST = {
  TITLE: TEXT_HEADER.SURVEY_LIST,
  PART: '件',
  CREATE_SURVEY: '問診票を作成',
  PLACE_SEARCH_SURVEY: '問診票を検索',
  SELECTING: '件選択中',
  CONSULTATION_TICKET_NAME: '問診票名',
  CONSULTATION_NAME: '問診名',
  EDITING_DATE: '最終編集日',
  CONFIRM_DELETE_SURVEY: '削除すると復元できません。本当に削除してもよろしいですか？',
  SELECTED_DELETED: '件の問診票が削除されました',
  REVERT_PUBLIC: TEXT_COMMON.REVERT_PUBLIC,
  TOOLTIP_CAN_BE_EDIT: '非公開または下書きの状態で編集可能です',
};

export const TEXT_CREATE_SURVEY = {
  SURVEY_LIST: TEXT_SURVEY_LIST.TITLE,
  NEW_SURVEY: '新規問診票',
  SAVE_DRAFT: '下書き保存',
  SAVE_PUBLIC: '公開する',
  SAVE: '保存する',
  CONFIRM_DELETE_SURVEY: '削除すると入力中のデータが全てなくなります。よろしいでしょうか。',
  PLACEHOLDER_ENTER_TITLE_SURVEY: 'タイトルを入力',
  PLACEHOLDER_ENTER_DESCRIPTION_SURVEY: '説明を入力（省略可）',
  CONFIRM_DELETE_SECTION: '質問とセクションを削除しますか?',
  PLACEHOLDER_ENTER_TITLE_SECTION: 'タイトルを入力',
  PLACEHOLDER_ENTER_DESCRIPTION_SECTION: '説明を入力（省略可）',
  PLACEHOLDER_SHORT_TEXT: '短文を回答',
  PLACEHOLDER_PARAGRAPH: '長文を回答',
  PLACEHOLDER_DROPDOWN: '選択してください',
  PLACEHOLDER_DATE: '選択してください',
  OPTION: '選択肢',
  ADD_OPTION: '選択肢を追加',
  PLACEHOLDER_DATE_FORMAT: '月　日',
  PLACEHOLDER_DATE_YEAR_FORMAT: '年　月　日',
  PLACEHOLDER_ENTER_THE_QUESTION: '質問を入力',
  PLACEHOLDER_SELECT_QUESTION: '質問の種類',
  PLACEHOLDER_ENTER_DESCRIPTION_QUESTION: '説明を入力（省略可）',
  TITLE_PARAGRAPH: '段落タイトル',
  MUST: '必須',
  EXPRESS: '表示',
  SECTION_COPY: 'セクションをコピー',
  SECTION_MOVE: 'セクションを移動',
  SECTION_UPDATE_TITLE: 'セクションの並べ替え',
  SECTION: 'セクション ',
  SURVEY_TYPE: '該当する問診票の種類を選択してください',
  CREATE_OPTIONS_TITLE: '新規問診票作成',
  CREATE_OPTIONS: '該当する問診票の種類を選択してください',
  BUTTON_CREATE_OPTIONS: '問診票を作成',
  CHILD_5_YEAR_OLD_CHECKUP: '5 歳児健診',
  CHILD_5_YEAR_OLD_CHECKUP_DESCRIPTION: '{name_survey}では、定型の問診票を使用します',
  CHILD_OTHER: 'その他',
  TEXT_CREATE_CHILD_OTHER_OPTIONS: '問診票の種類',
  TEXT_IF_YOU_UPLOAD_VIDEO: '※ 動画がアップロードされた場合',
  UPLOAD_VIDEO_INSTRUCTION: '気になる場面の動画をアップロードしてください（最大{max_video}本まで）',
  UPLOAD_IMAGE_INSTRUCTION: '母子手帳の該当ページをアップロードしてください（最大5枚まで）',
  TEXT_IF_YOU_CHOOSE: '※{choose_type}が選択された場合',
  CUSTOM_SURVEY: 'カスタム問診表',
  SURE_ANSWER: '※の付いた項目は、必ずご回答ください。',
  SURVEY_CONFIGURATION: 'この問診票は、全13ステップ・約80問の構成です。',
  SURVEY_TIME: '回答には1ステップ5~10分程度かかる場合があります。',
  NEED_UPLOAD_VIDEO_AND_IMAGE: 'また、記入に加えて動画や母子手帳のアップロードが必要になります。',
  MOBILE_SURVEY_INSTRUCTION_FIVE_YEAR_OLD: 'この問診票は、全13ステップ・約80問の構成です。',
  MOBILE_SURVEY_DESCRIPTION_FIVE_YEAR_OLD:
    '回答には10〜20分程度かかる場合があります。また、記入に加えて動画や母子手帳のアップロードが必要になります。',
  TEMPLATE_TITLE: '該当する問診票の種類',
  PUBLIC_PERIOD_SETTING: '公開期間設定',
  PUBLIC_CONFIRM: '公開を確定',
  START_TIME: '開始日時',
  END_TIME: '終了日時',
  PUBLIC_NOW: '今すぐ公開',
  PUBLIC_SPECIFY_DATE: '日時を指定',
  END_TIME_NOT_SET: '終了日時なし',
  PLACEHOLDER_END_TIME: '終了日時を選択',
  PLACEHOLDER_START_TIME: '開始日時を選択',
  PUBLIC_SUCCESS: '公開されました',
  PUBLIC_SUCCESS_END_TIME: '公開終了日時は{end_time}です',
  PUBLIC_SUCCESS_START_TIME: '公開開始日時は{start_time}です',
  PUBLIC_SUCCESS_PERIOD: '公開期間は{start_time}〜{end_time}です',
  DRAFT_PUBLIC_SETTING_START_TIME: '{start_time} から公開設定中です',
  DRAFT_PUBLIC_SETTING_PERIOD: '{start_time} から {end_time} まで公開設定中です',
  PUBLIC_SETTING_END_TIME: '{end_time} まで公開設定中です',
  CANCEL_PUBLIC_SETTING: '取消',
  CANCEL_SCHEDULE_CONFIRM: '取消する',
  CANCEL_SCHEDULE_CONFIRM_TITLE: '公開設定を取消ますか？',
  CHANGE_SETTING: '変更する',
  CHANGE_SETTING_TITLE: '公開期間設定を変更しますか？',
  CHANGE_SETTING_DESCRIPTION: '変更すると、元の設定が上書きされます。',
  BEFORE_CHANGE: '変更前：{start_time} 〜 {end_time}',
  AFTER_CHANGE: '変更後：{start_time} 〜 {end_time}',
  CHILD_5_YEAR_OLD_CHECKUP_REPORT: '5 歳児健診問診票・レポート',
  SURVEY_TITLE: '問診票：',
};

export const TEXT_PROFILE = {
  TITLE: 'アカウント情報設定',
  EMAIL_ADDRESS: TEXT_LOGIN.EMAIL_ADDRESS,
  PASSWORD: TEXT_LOGIN.PASSWORD,
  MUNICIPALITY: TEXT_REGISTER.MUNICIPALITY,
  MUNICIPALITY_REQUIRED: TEXT_REGISTER.MUNICIPALITY_REQUIRED,
  DEPARTMENT: TEXT_REGISTER.DEPARTMENT,
  DEPARTMENT_REQUIRED: TEXT_REGISTER.DEPARTMENT_REQUIRED,
  TITLE_EMAIL_EDITING: 'メールアドレス編集',
  REQUIRED_EMAIL_TEXT: TEXT_REGISTER.REQUIRED_EMAIL_TEXT,
  TITLE_PROFILE_EDITING: '所属自治体、所属部署編集',
  TITLE_PROFILE_EDITING_USER: '所属部署編集',
  TITLE_PASSWORD_EDITING: 'パスワード編集',
  OLD_PASSWORD: '古いパスワード',
  NEW_PASSWORD: TEXT_FORGOT_PASSWORD.NEW_PASSWORD,
  NEW_PASSWORD_CONFIRM: TEXT_FORGOT_PASSWORD.NEW_PASSWORD_CONFIRM,
  PASSWORD_REQUIRED_TEXT: TEXT_REGISTER.PASSWORD_REQUIRED_TEXT,
};

export const TEXT_REPORT_LIST = {
  TITLE: '回答結果一覧',
  TEXT_FILTER: '絞り込む',
  ANSWER_DAY: '回答日',
  PLACE_SEARCH_REPORT: '子供IDを検索',
  SELECTING: TEXT_SURVEY_LIST.SELECTING,
  PART: TEXT_SURVEY_LIST.PART,
  SELECTED_DELETED: '件の回答結果が削除されました。',
  CONFIRM_DELETE_SURVEY: TEXT_SURVEY_LIST.CONFIRM_DELETE_SURVEY,
  USER_ID: '子供ID',
  DIAGNOSIS: '問診名',
  CHILD_3_YEAR_OLD: '3歳児検診',
  SDQ_TEXT: 'SDQ・独自アンケート',
  REPORT: 'レポート',
  SDQ_REPORT: 'SDQ・独自アンケート・レポート',
  LOCAL_GOVERNMENT_SURVEY: '自治体問診票',
};

export const TEXT_RESULT_REPORT = {
  ANSWER_RESULT: '回答結果',
  ANALYSIS_REPORT: '分析レポート',
  ADDITIONAL_CONTENT: '追記したい内容があればお書きください',
  VIDEO_TUTORIAL: '検査手順',
  VIDEO_CATEGORY: 'チェックポイント',
};

export const TEXT_APP_SCREEN_PREVIEW = {
  APP_SCREEN_PREVIEW: 'アプリ画面プレビュー',
  QUESTION_SECTION: '問診票セクション',
  SUBMIT: '入力情報を確認',
  BACK: '戻る',
  NEXT: '次へ',
};

export const TEXT_VIEW_SURVEY = {
  DUPLICATE_TEXT: '問診票複製作成',
  CREATE_A_DUPLICATE: '複製を作成',
  TITLE: 'タイトル',
};

export const TEXT_DOWNLOAD = {
  CSV_DOWNLOAD: 'CSVファイルダウンロード',
  EXCEL_DOWNLOAD: 'Excelファイルダウンロード',
  DOWNLOAD: 'ダウンロード',
  CSV_DOWNLOAD_CONFIRMATION: 'CSVファイルダウンロード確認',
  EXCEl_DOWNLOAD_CONFIRMATION: 'Excelファイルダウンロード確認',
};

export const TEXT_USER_LIST = {
  TITLE: '子供一覧',
  CREATE_USER: 'ユーザーを作成',
  EMAIL_TEXT: 'メールアドレス',
  STATUS_TEXT: '状態',
  LOCAL_GOVERNMENT: '所属自治体',
  EDITING_DATE: '最終編集日',
  APPROVE: '承認する',
  REJECT: '拒否する',
  VIEW: '閲覧',
  APPROVED_TEXT: '承認された',
  NEW_TEXT: '未承認',
  REJECTED_TEXT: '拒否された',
  PART: '件',
  APPROVE_CONFIRM_TEXT: 'このユーザを承認します。よろしいでしょうか。',
  REJECT_CONFIRM_TEXT: 'このユーザを拒否します。よろしいでしょうか。',
  ACCOUNT_SETTING: 'アカウント情報更新',
  LOCAL_GOVERNMENT_EDITTING: '地方自治体編集',
  PLACEHOLDER_SEARCH: 'メールアドレスを検索する',
  TEXT_FILTER: '絞り込む',
  TEXT_FILTER_TYPE: '所属自治体',
  UNLOCK_USER_CONFIRM: 'アカウントのロックを解除します。よろしいでしょうか。',
};

export const TEXT_SAMPLE_VIDEO_LIST = {
  TITLE: '参考動画・画像一覧',
  CREATE_SAMPLE_VIDEO: '参考動画・画像を新規に作成',
  EXERCISE_NAME: '運動名',
  EXERCISE_CATEGORY: '運動カテゴリー',
  APPLICABLE_TARGET: '適用対象',
  PLACEHOLDER_EMAIL: 'メールアドレス',
  PLACEHOLDER_EXERCISE_CATEGORY: '運動カテゴリー',
  PLACEHOLDER_APPLICABLE_TARGET: '適用対象',
  PLACEHOLDER: '運動カテゴリー',
};
